import { notification } from 'antd';

/**
 * @param {Object} props - Component properties
 * @param {'success' | 'error' | 'info' | 'warning'} props.type - The type of notification
 * @param {string} props.message - Title of the notification
 * @param {string} [props.description] - Optional description
 * @param {boolean} [props.open] - Whether to show the notification
 * @param {Function} [props.onClose] - Callback when notification closes
 */
const NotifResult = ({ type = 'success', message, description, onClose }) => {
    notification[type]({
        message,
        description,
        placement: 'top',
        onClose,
        className: `custom-notification ${type}`,
        style: {
            zIndex: 99999,
        },
        ...(type === 'error' && { duration: null }),
    });
};

export default NotifResult;
